import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toast"]

  connect() {
    this._outsideClick = this._outsideClick.bind(this)
    this.element.addEventListener("toggle", this._onToggle.bind(this))
  }

  disconnect() {
    document.removeEventListener("click", this._outsideClick)
  }

  _onToggle() {
    if (this.element.open) {
      // fecha todos os outros dropdowns de pdf-download abertos
      document.querySelectorAll("details[data-controller='pdf-download']").forEach(el => {
        if (el !== this.element) el.removeAttribute("open")
      })
      // adiciona listener de fora no próximo tick para não colidir com o clique que abriu
      setTimeout(() => document.addEventListener("click", this._outsideClick), 0)
    } else {
      document.removeEventListener("click", this._outsideClick)
    }
  }

  _outsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.element.removeAttribute("open")
      document.removeEventListener("click", this._outsideClick)
    }
  }

  download() {
    this.element.removeAttribute("open")
    this.toastTarget.classList.remove("hidden")
    clearTimeout(this._timer)
    this._timer = setTimeout(() => this.toastTarget.classList.add("hidden"), 3500)
  }
}
